/**
 * parseServerTime — MariaDB returns timestamps in UTC but without a "Z"
 * suffix, so JavaScript's Date constructor interprets them as local time.
 * For a user in UTC+2 this means timestamps appear ~2 hours in the future,
 * which produces negative "last seen" values like "-7130s ago".
 *
 * This helper normalizes the input so timestamps without explicit timezone
 * markers are treated as UTC.
 */
export function parseServerTime(input) {
  if (!input) return null;
  if (input instanceof Date) return input;
  if (typeof input !== "string") return new Date(input);
  // Already has explicit timezone info?
  if (input.endsWith("Z") || /[+-]\d{2}:?\d{2}$/.test(input)) {
    return new Date(input);
  }
  // MariaDB format: "2026-05-13 15:30:00" → assume UTC
  return new Date(input.replace(" ", "T") + "Z");
}

export function timeMs(input) {
  const d = parseServerTime(input);
  return d ? d.getTime() : 0;
}
